import { useCallback } from "react";
import { useMessageToState } from "../../../hooks/useMessageToState";

/** Return the color of the selected zone */
export const useSelectedTextColor = (selectedZone: eXpress.core.IZone | undefined) => {
	return useMessageToState({
		name: "useSelectedTextColor",
		getState: useCallback(
			() =>
				eXpress.core.isAnyTextZone(selectedZone)
					? eXpress.HexColorString.fromString(
							selectedZone.textSettings.foregroundColor.webColor,
					  )
					: undefined,
			[selectedZone],
		),
		// Didn't choose to check message type, because code is fast enough and will be always correct
	});
};
